// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1SCW9","buttons":"RemoveExpirationActionButtons_buttons__oj1Nz"};